import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import { createRoot } from 'react-dom/client'

import { App } from './App'
import './i18n'
import './setLocationHref'

declare global {
  interface Window {
    recaptchaOptions: {
      enterprise: boolean
      nonce: string
    }
  }
}

window.recaptchaOptions = {
  enterprise: true,
  nonce: window.__dhlConfig?.CSP_NONCE, // eslint-disable-line no-underscore-dangle
}

const container = document.getElementById('root')
if (container) {
  const root = createRoot(container)
  root.render(<App />)
}
